import { render, staticRenderFns } from "./privacy-policy-archive.vue?vue&type=template&id=b16e1d5a&scoped=true&"
import script from "./privacy-policy-archive.vue?vue&type=script&lang=ts&"
export * from "./privacy-policy-archive.vue?vue&type=script&lang=ts&"
import style0 from "./privacy-policy-archive.vue?vue&type=style&index=0&id=b16e1d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16e1d5a",
  null
  
)

export default component.exports